export type ClampBoundedNumberParams = {
  max: number | null;
  min: number;
  raw: string;
};

export const clampBoundedNumber = ({ max, min, raw }: ClampBoundedNumberParams): number => {
  const parsed = Number(raw);

  if (!Number.isFinite(parsed) || parsed <= min) {
    return min;
  }

  if (max !== null && parsed >= max) {
    return max;
  }

  return Math.round(parsed);
};

/** Clamps a numeric string onto `[min, max]`. */
export const clampBoundedNumberString = (params: ClampBoundedNumberParams) => clampBoundedNumber(params);
